@if (department) {
  <div class="department-item">
    <div class="department-item__header">
      <app-avatar
        [size]="44"
        [displayName]="department.name || ''"
        [iconUrl]="transportIconUrl"
        color="var(--sgl-avatar-department)"
        textColor="var(--sgl-avatar-department-text)"></app-avatar>
      <div class="department-item__header--details">
        <span class="department-item__header--name">{{ department.name }}</span>
        <span class="department-item__header--label">Department</span>
      </div>
    </div>
    @if (department.description) {
      <p class="department-item__description">{{ department.description }}</p>
    }
    <app-contact-rows [contact]="department" cardType="department"></app-contact-rows>
  </div>
}
